export default {
    DatasParaDebito: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "datas-para-debito"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/DatasParaDebito.js
// module id = ZgUr
// module chunks = 13